import * as httpx from "httpx"
import * as events from "./events"
import { CancellablePromise } from "real-cancellable-promise"
import {
	VideoSearchRequest,
	VideoSearchResponse,
	VideoFindResponse,
	VideoPatchRequest,
	VideoPatchResponse,
} from "brandguard/brandguard.video_pb"

export namespace requests {
	export function search(d: Partial<VideoSearchRequest> = {}): VideoSearchRequest {
		return {
			offset: 0n,
			queues: [],
			uploaded_by: [],
			deprecated_uploaded_by: "",
			brand_id: "",
			limit: 10n,
			observation: [],
			approved: [],
			...d,
		}
	}
}

export function search(
	bid: string,
	req: VideoSearchRequest,
	...options: httpx.option[]
): CancellablePromise<VideoSearchResponse> {
	return httpx
		.get<VideoSearchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/approvallog`, req, ...options)
		.then((resp) => ({
			...resp,
			items: (resp.items || []).map((item) => ({ media: item.media, event: events.zero(item.event) })),
		}))
}

export function find(id: string, bid: string, ...options: httpx.option[]): Promise<VideoFindResponse> {
	return httpx
		.get<VideoFindResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/approvallog/${id}`, {}, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}

export function patch(
	id: string,
	bid: string,
	req: VideoPatchRequest,
	...options: httpx.option[]
): Promise<VideoPatchResponse> {
	return httpx
		.patch<VideoPatchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/approvallog/${id}`, req, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}

export function destroy(bid: string, id: string, ...options: httpx.option[]): Promise<VideoPatchResponse> {
	return httpx
		.destroy<VideoPatchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/video/approvallog/${id}`, {}, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
		}))
}
